<template>
  <div class="content" :class="['scroll', scroolStarrysky ? 'scroolStarrysky' : '']">
    <t-head-menu :defaultValue="routethen" v-model="routethen" theme="light" height="120px" expand-type="popup" @change="changeMenu">
      <template #logo>
        <div class="logo">
          <img v-if="platform.icon" :src="platform.icon" alt="" />&nbsp;
          <span>{{ platform.name }}</span>
        </div>
        <i class="w1px"></i>
        <div class="logo">
          <img  :src="require('@/assets/tupu.png')" alt="" />&nbsp;
          <span>{{$t('resListDetail.zstp')}}</span>
        </div>
      </template>
      
      <template v-for="(items, index) in menuData" :key="index + 'h'">
        <!-- 一级菜单 -->
        <t-menu-item :value="items.menuId" 
        v-bind="/^https?:\/\//.test(items.path) 
        ? { href: items.path, target: '_blank' } 
        : { to: { path: items.path, query: { id: route.query.id } } }"
          >
          {{ items.name }}
        </t-menu-item>
       
      </template>
      
      <img class="Group734" src="@/assets/Group734.svg" alt=""  />

     
    </t-head-menu>

  </div>

</template>
<script setup>
import Cookies from "js-cookie";
import {
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
  reactive,
  watch
} from "vue";

import { useRouter, useRoute } from "vue-router";

import { navigation } from "@/api/limitsOfAuthority.js";
import { getInfoInDividuation } from "@/api/Equipment.js";
import store from "@/store";

import i18n from "@/utils/i18n";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const router = useRouter();
const route = useRoute();
// 尝试从 Cookie 中获取 userInfo 字符串
const userInfoString = Cookies.get("userInfo");

// 尝试解析 userInfo 字符串为对象，如果解析失败则返回空对象
let initialUserInfo = {};
try {
  initialUserInfo = userInfoString ? JSON.parse(userInfoString) : {};
} catch (error) {
  console.error("Error parsing userInfo from Cookie:", error);
}

const userInfo = ref(initialUserInfo);
const userId = ref("");

if (userInfo.value) {
  userId.value = userInfo.value.userId;
}

let getSchoolId = "";
if (Cookies.get("schoolId")) {
  getSchoolId = Cookies.get("schoolId");
}

var getToken = Cookies.get("tokenValue");
const Identity = ref(localStorage.getItem("Identity")); // 身份id（1：管理员、2：教师、3：学生、4：家长、5：游客）
const myRefMessageList = ref(null);
const isScrolled = ref(false);

let getMenuData = () => {
  navigation({
    filterFieldOne: 2,
  }).then((res) => {
    if (res.code == 1) {
 
      menuData.value = res.data;
    }
  });
};

const menuData = ref([
  {
    name: t("resListDetail.zstp"),
    path: "/mapping/KnowledgeGraph",
    menuId: "KnowledgeGraph",
  },
  {
    name: t("resListDetail.nltp"),
    path: "/mapping/AbilityMap",
    menuId: "AbilityMap",
  },
  {
    name: t("resListDetail.wttp"),
    path: "/mapping/ProblemGraph",
    menuId: "ProblemGraph",
  },
  {
    name: t("resListDetail.zytp"),
    path: "/mapping/ResourceMap",
    menuId: "ResourceMap",
  },

]);

const changeMenu = (value) => {
  console.log(value);
  if(value == "KnowledgeGraph"){
    store.dispatch('setScroolStarrysky', true);
  }else{
    store.dispatch('setScroolStarrysky', false);
  }
}


// 获取平台名称
const platform = reactive({
  name: "",
  icon: "",
});
const getPlatForm = () => {
  let pfId = 2;
  getInfoInDividuation(pfId, getSchoolId).then((res) => {
    if (res.code === 1) {
      if (res.data) {
        // 传id修改
        platform.name = res.data.name;
        platform.icon = res.data.icon;
        window.document.title = res.data.name;
      }
    }
  });
 
};

// 获取路由meta
const routethen = computed(() => {
  return route.meta.affiliation_Head;
});


const scroolStarrysky = computed(() => {
  return store.getters.getScroolStarrysky;
});

onMounted(() => {
  document.title = t("PlatformName"); // 设置页面title
  //首次加载
  // getMenuData();
  getPlatForm();

});

onBeforeUnmount(() => {

});


</script>
<style lang="less" scoped>
@import "./index.less";
</style>
